import {
    changeLearningStatus,
    DesignFile,
    DesignFileView,
    getSimulationDetail,
    getSimulationList,
    getSimulationResrouceDetail,
    Simulation,
    SimulationDetail,
    UploadFile,
    ViewFile
} from "@/api/custom-simulation";
import { Module } from "vuex";
import * as api from "@/api";
import { SimulationType } from "@/constants/custom-simulation";
import { safeJsonParse } from "@/utils/safe-json-parse";

type CustomSimulationState = {
    simulationList: Simulation[];
    currentSimulation: Simulation;
    currentSimulationDetail: SimulationDetail[];
    selectedSimulationDetail: SimulationDetail;
    currentSimulationResource: {
        designFile: DesignFile;
        uploadFile: UploadFile;
        viewFile: ViewFile;
        designFileViewList: DesignFileView[];
    };
    selectedInstanceId: number;
    selectedFilter: {
        grade: string;
        major: string;
    };
    simulationListLoading: boolean;
    isFold: boolean;
};
const initialState: CustomSimulationState = {
    selectedInstanceId: 0,
    simulationList: [],
    currentSimulation: {
        beginTime: "",
        createNickName: "",
        createUserId: 0,
        createUserName: "",
        creationTime: "",
        description: "",
        designFinishStatus: 0,
        endTime: "",
        id: 0,
        logo: "",
        status: 0,
        title: "",
        typeId: 0,
        major: "",
        grade: "",
        step: 0
    },
    currentSimulationDetail: [],
    selectedSimulationDetail: {
        classType: 0,
        createUserId: 0,
        creationTime: "",
        designFileId: 0,
        designTaskId: 0,
        id: 0,
        sort: 0,
        title: "",
        viewSettings: ""
    },
    currentSimulationResource: {
        designFile: {
            name: "",
            classType: 0,
            uploadFileId: 0,
            typeId: 0,
            isFinish: false,
            viewFileId: 0,
            creationTime: "",
            createUserId: 0,
            id: 0
        },
        uploadFile: {
            fileId: "",
            fileName: "",
            fileExtention: "",
            fileConvertState: 0,
            fileSize: 0,
            fileUrl: "",
            creationTime: "",
            createUserId: 0,
            id: 0
        },
        viewFile: {
            fileId: "",
            fileName: "",
            fileExtention: "",
            fileConvertState: 0,
            fileSize: 0,
            fileUrl: "",
            creationTime: "",
            createUserId: 0,
            id: 0
        },
        designFileViewList: []
    },
    selectedFilter: {
        grade: "",
        major: ""
    },
    simulationListLoading: true,
    isFold: false
};
const customSimulationModule: Module<CustomSimulationState, any> = {
    namespaced: true,
    state: { ...initialState },
    getters: {
        simulationHomePage(state) {
            return state.currentSimulationDetail.find(v => v.classType === SimulationType.homePage);
        },
        bindedList(state) {
            return state.currentSimulationResource.designFileViewList?.filter(
                v => safeJsonParse(v.viewSettings)?.componentIds?.length
            );
        }
    },
    mutations: {
        setSimulationList(state, payload) {
            state.simulationList = payload;
        },
        setCurrentSimulationDetail(state, payload) {
            state.currentSimulationDetail = payload;
        },
        setCurrentSimulation(state, payload) {
            state.currentSimulation = payload;
        },
        setCurrentSimulationResource(state, payload) {
            state.currentSimulationResource = payload;
        },
        setSelectedSimulationDetail(state, payload) {
            state.selectedSimulationDetail = payload;
        },
        setSelectedInstanceId(state, payload) {
            state.selectedInstanceId = payload;
        },
        setSelectedFilter(state, payload) {
            state.selectedFilter = payload;
        },
        setSimulationListLoading(state, payload) {
            state.simulationListLoading = payload;
        },
        setIsFold(state, payload) {
            state.isFold = payload;
        }
    },
    actions: {
        async getSimulationList({ commit, dispatch, getters, state }, { filter, major, grade }) {
            commit("setSimulationListLoading", true);
            const res = await getSimulationList({
                maxResultCount: 999,
                skipCount: 0,
                status: 1,
                filter,
                major,
                grade
            });
            if (res && !api.error(res)) {
                commit("setSimulationList", res.data.items);
                commit("setSimulationListLoading", false);
            }
        },
        async getSimulationDetail({ commit, dispatch, getters, state }, { designTaskId }) {
            const res = await getSimulationDetail({
                designTaskId
            });
            if (res && !api.error(res)) {
                commit("setCurrentSimulationDetail", res.data);
            }
        },
        async changeLearningStatus(
            { commit, dispatch, getters, state },
            { designTaskId, status, targetId, step }
        ) {
            const res = await changeLearningStatus({
                designTaskId,
                status,
                targetId,
                step
            });
            if (res && !api.error(res)) {
                dispatch("getSimulationList", {});
            }
        },
        async getSimulationResrouceDetail({ commit, dispatch, getters, state }, { designFileId }) {
            const res = await getSimulationResrouceDetail({ designFileId });
            if (res && !api.error(res)) {
                commit("setCurrentSimulationResource", res.data);
            }
        },
        async setNextSimulationDetail({ commit, dispatch, getters, state, rootState }, payload) {
            const currentIsFinish =
                state.currentSimulation.step === state.currentSimulationDetail.length - 2;
            await dispatch("changeLearningStatus", {
                designTaskId: state.currentSimulation.id,
                status: currentIsFinish ? 2 : 1,
                targetId: rootState.user.userId,
                step: currentIsFinish
                    ? state.currentSimulation.step
                    : state.currentSimulation.step + 1
            });
            commit("setCurrentSimulation", {
                ...state.currentSimulation,
                step: state.currentSimulation.step + 1
            });
            commit("setSelectedSimulationDetail", {
                ...state.currentSimulationDetail.find(
                    v => v.sort === state.selectedSimulationDetail.sort + 1
                )
            });
            if (state.selectedSimulationDetail?.id) {
                await dispatch("getSimulationResrouceDetail", {
                    designFileId: state.selectedSimulationDetail.designFileId
                });
            }
        }
    }
};
export default customSimulationModule;
